import { useBrandStore } from "../store/brand";
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

export const useBrand = () => {
  const brandStore = useBrandStore();
  const { t } = useI18n();
  const route = useRoute();

  watch(
    () => route.params?.brand || route.params?.distributor || localStorage.brand,
    (value) => {
      //Sporttravel will use a different URL structure than the other brands, so we need to check the URL instead of the route params
      if (window.location.href.includes("sporttravel")) {
        brandStore.fetchBrand("SportTravel");
        return;
      }

      if (!value) {
        return;
      }

      brandStore.fetchBrand(value);
    },
    { immediate: true }
  );

  //Set initial color based on loaded stylesheet
  const initialPrimaryColor = getComputedStyle(document.body).getPropertyValue("--color-primary");
  const initialSecondaryColor = getComputedStyle(document.body).getPropertyValue("--color-secondary");

  //Set initial font based on loaded stylesheet
  const initialFontFamily = getComputedStyle(document.body).getPropertyValue("font-family");

  const primary = computed(() => {
    if (brandStore.data?.corporate_color) {
      return brandStore.data.corporate_color;
    }

    return initialPrimaryColor;
  });

  const secondary = computed(() => {
    if (brandStore.data?.narrative_color) {
      return brandStore.data.narrative_color;
    }

    return initialSecondaryColor;
  });

  const fontFamily = computed(() => {
    if (brandStore.data?.font_family) {
      return `${brandStore.data.font_family}, sans-serif`;
    }
    return initialFontFamily;
  });

  const documentTitle = computed(() => {
    const titles = [];

    if (route.meta.title) {
      titles.push(t(route.meta.title));
    }

    if (brandStore.data?.distributor_name) {
      titles.push(brandStore.data.distributor_name);
    }

    return titles.join(" | ");
  });

  watch(
    documentTitle,
    (title) => {
      document.title = title;
    },
    { immediate: true }
  );
  return { primary, secondary, fontFamily };
};
